import { Component, Output, EventEmitter } from "@angular/core";
import { NgForm } from "@angular/forms";

@Component({
  selector: "enter-channel-name",
  templateUrl: "./enter-channel-name.component.html",
  styleUrls: ["./enter-channel-name.component.scss"],
})
export class EnterChannelName {
  channelName: string = "";

  @Output()
  channelNameCreated = new EventEmitter<string>();
  onSubmitForm(form: NgForm) {
    if (form.valid && this.channelName && this.channelName.trim()) {
      this.channelNameCreated.emit(this.channelName);
    } else {
      Object.keys(form.controls).forEach((field) => {
        const control = form.controls[field];
        console.log("control errors", control.errors);
        control.markAsTouched({ onlySelf: true });
      });
    }
    this.channelName = "";
  }
}
